import {get} from '@/bank/bankApi.service'
import {z} from 'zod'

const MoneySchema = z.object({
    amount: z.number(),
    currency: z.string()
})
const OcrTransactionTypeSchema = z.enum(['KID', 'Cremul'])
const RemittanceTypeSchema = z.enum(['Kid', 'InvoiceNo', 'Unstructured'])
const RemittanceSchema = z.object({
    value: z.string(),
    type: RemittanceTypeSchema
})

const OcrTransactionSchema = z.object({
    uuid: z.uuid(),
    receiver: z.object({ // TODO should be bank service bank account schema
        uuid: z.uuid(),
        name: z.string(),
        bban: z.string()
    }),
    type: OcrTransactionTypeSchema,
    remittance: RemittanceSchema,
    valueAt: z.iso.datetime(),
    senderAccountNo: z.string(),
    money: MoneySchema
})

export type RemittanceType = z.infer<typeof RemittanceTypeSchema>
export type Remittance = z.infer<typeof RemittanceSchema>
export type Money = z.infer<typeof MoneySchema>
export type OcrTransactionType = z.infer<typeof OcrTransactionTypeSchema>
export type OcrTransaction = z.infer<typeof OcrTransactionSchema>

export const findOcrTransaction = (uuid: string): Promise<OcrTransaction> => {
    return get(`/ocr/${uuid}`)
}